const initialState = {
    isDataAvailable: false,
    message:"",
    tables:[],
    bookedInfos: [],
    searchBookedInfos:{}
}

export default initialState;
